import React, { useEffect } from 'react';
import { ListingType } from '@domain-group/fe-allhomes-library';
import ListingSearchResults from '@domain-group/fe-pa-allhomes-listing-search-results';
import { usePageContext } from '@domain-group/fe-co-allhomes-api-client';
import StandardPage from './common/standard-page.js';

/* eslint-disable react/jsx-filename-extension */
const SearchResultPage = (props) => {
  const [header, updateHeaderContext] = usePageContext('fe-co-allhomes-header');
  const [searchPage = {}] = usePageContext(
    'fe-pa-allhomes-listing-search-results',
  );

  const { searchQuery } = searchPage;

  useEffect(() => {
    if (searchQuery) {
      const activeNavItem =
        searchQuery.isSold() &&
        searchQuery.filters.listingType === ListingType.SALES_RESIDENTIAL.name
          ? 'SOLD_RESIDENTIAL'
          : searchQuery.filters.listingType;
      if (activeNavItem !== header.activeNavItem) {
        updateHeaderContext({
          ...header,
          activeNavItem,
        });
      }
    }
  }, [searchQuery, header, updateHeaderContext]);

  return <ListingSearchResults {...props} />;
};

export default (props) => (
  <StandardPage component={SearchResultPage} {...props} />
);
